import { api } from '~/plugins/api'
import { InadimplentesRepository } from './inadimplentes-repository'

export * from './assessor'
export * from './boleto'
export * from './cobranca'
export * from './condominio'
export * from './endereco'
export * from './filial'
export * from './inadimplentes-repository'
export * from './unidade'

export const inadimplente_repository = new InadimplentesRepository(api)